// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/collab/v1/collab.proto (package mono.collab.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * ShareType is the kind of access a ChatShare grants. Mirrors pangaea's
 * SHARE_TYPE_LINK / SHARE_TYPE_DIRECT enum at the wire and Go/TS type
 * levels; the values are not transferred bit-for-bit (the gateway maps
 * between the two enums), so renumbering one does not break the other.
 *
 * @generated from enum mono.collab.v1.ShareType
 */ export var ShareType = /*#__PURE__*/ function(ShareType) {
    /**
   * @generated from enum value: SHARE_TYPE_UNSPECIFIED = 0;
   */ ShareType[ShareType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: SHARE_TYPE_LINK = 1;
   */ ShareType[ShareType["LINK"] = 1] = "LINK";
    /**
   * @generated from enum value: SHARE_TYPE_DIRECT = 2;
   */ ShareType[ShareType["DIRECT"] = 2] = "DIRECT";
    return ShareType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ShareType)
proto3.util.setEnumType(ShareType, "mono.collab.v1.ShareType", [
    {
        no: 0,
        name: "SHARE_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SHARE_TYPE_LINK"
    },
    {
        no: 2,
        name: "SHARE_TYPE_DIRECT"
    }
]);
/**
 * LinkExpiration matches the express schema's discrete expiration values.
 * Custom durations are intentionally not supported — the UI surfaces a
 * dropdown of preset windows and the server has the only authoritative
 * clock.
 *
 * @generated from enum mono.collab.v1.LinkExpiration
 */ export var LinkExpiration = /*#__PURE__*/ function(LinkExpiration) {
    /**
   * @generated from enum value: LINK_EXPIRATION_UNSPECIFIED = 0;
   */ LinkExpiration[LinkExpiration["LINK_EXPIRATION_UNSPECIFIED"] = 0] = "LINK_EXPIRATION_UNSPECIFIED";
    /**
   * @generated from enum value: LINK_EXPIRATION_NEVER = 1;
   */ LinkExpiration[LinkExpiration["LINK_EXPIRATION_NEVER"] = 1] = "LINK_EXPIRATION_NEVER";
    /**
   * @generated from enum value: LINK_EXPIRATION_7D = 2;
   */ LinkExpiration[LinkExpiration["LINK_EXPIRATION_7D"] = 2] = "LINK_EXPIRATION_7D";
    /**
   * @generated from enum value: LINK_EXPIRATION_30D = 3;
   */ LinkExpiration[LinkExpiration["LINK_EXPIRATION_30D"] = 3] = "LINK_EXPIRATION_30D";
    /**
   * @generated from enum value: LINK_EXPIRATION_90D = 4;
   */ LinkExpiration[LinkExpiration["LINK_EXPIRATION_90D"] = 4] = "LINK_EXPIRATION_90D";
    return LinkExpiration;
}({});
// Retrieve enum metadata with: proto3.getEnumType(LinkExpiration)
proto3.util.setEnumType(LinkExpiration, "mono.collab.v1.LinkExpiration", [
    {
        no: 0,
        name: "LINK_EXPIRATION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "LINK_EXPIRATION_NEVER"
    },
    {
        no: 2,
        name: "LINK_EXPIRATION_7D"
    },
    {
        no: 3,
        name: "LINK_EXPIRATION_30D"
    },
    {
        no: 4,
        name: "LINK_EXPIRATION_90D"
    }
]);
/**
 * DirectShareRecipient is the recipient for a direct share. Mirrors the
 * shareChat REST handler's `users[]` payload. companyId is optional —
 * when unset the server uses the caller's tenant (cross-tenant shares
 * are rejected with ShareError on the response, not at the wire).
 *
 * @generated from message mono.collab.v1.DirectShareRecipient
 */ export class DirectShareRecipient extends Message {
    static fromBinary(bytes, options) {
        return new DirectShareRecipient().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DirectShareRecipient().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DirectShareRecipient().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DirectShareRecipient, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DirectShareRecipient, "runtime", proto3);
_define_property(DirectShareRecipient, "typeName", "mono.collab.v1.DirectShareRecipient");
_define_property(DirectShareRecipient, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ShareSummary is the per-share payload returned from ShareConversation.
 * shape mirrors the express `ShareResult` interface 1:1 so the frontend
 * can swap the fetch for a Connect call without remapping fields.
 *
 * @generated from message mono.collab.v1.ShareSummary
 */ export class ShareSummary extends Message {
    static fromBinary(bytes, options) {
        return new ShareSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string share_id = 1;
   */ _define_property(this, "shareId", ""), /**
   * @generated from field: mono.collab.v1.ShareType share_type = 2;
   */ _define_property(this, "shareType", 0), /**
   * @generated from field: string shared_with_user_id = 3;
   */ _define_property(this, "sharedWithUserId", ""), /**
   * @generated from field: string shared_with_email = 4;
   */ _define_property(this, "sharedWithEmail", ""), /**
   * @generated from field: string shared_with_name = 5;
   */ _define_property(this, "sharedWithName", ""), /**
   * @generated from field: string link_token = 6;
   */ _define_property(this, "linkToken", ""), /**
   * @generated from field: bool link_enabled = 7;
   */ _define_property(this, "linkEnabled", false), /**
   * @generated from field: google.protobuf.Timestamp link_expires_at = 8;
   */ _define_property(this, "linkExpiresAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShareSummary, "runtime", proto3);
_define_property(ShareSummary, "typeName", "mono.collab.v1.ShareSummary");
_define_property(ShareSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "share_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "share_type",
            kind: "enum",
            T: proto3.getEnumType(ShareType)
        },
        {
            no: 3,
            name: "shared_with_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "shared_with_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "shared_with_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "link_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "link_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "link_expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ShareError carries a per-recipient failure reason (same recipient
 * list, server walks each one; non-fatal errors surface here rather
 * than failing the whole RPC).
 *
 * @generated from message mono.collab.v1.ShareError
 */ export class ShareError extends Message {
    static fromBinary(bytes, options) {
        return new ShareError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareError, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShareError, "runtime", proto3);
_define_property(ShareError, "typeName", "mono.collab.v1.ShareError");
_define_property(ShareError, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.ShareConversationRequest
 */ export class ShareConversationRequest extends Message {
    static fromBinary(bytes, options) {
        return new ShareConversationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareConversationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareConversationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareConversationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: repeated mono.collab.v1.DirectShareRecipient users = 2;
   */ _define_property(this, "users", []), /**
   * @generated from field: bool create_link = 3;
   */ _define_property(this, "createLink", false), /**
   * @generated from field: mono.collab.v1.LinkExpiration link_expiration = 4;
   */ _define_property(this, "linkExpiration", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShareConversationRequest, "runtime", proto3);
_define_property(ShareConversationRequest, "typeName", "mono.collab.v1.ShareConversationRequest");
_define_property(ShareConversationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "users",
            kind: "message",
            T: DirectShareRecipient,
            repeated: true
        },
        {
            no: 3,
            name: "create_link",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "link_expiration",
            kind: "enum",
            T: proto3.getEnumType(LinkExpiration)
        }
    ]));
/**
 * @generated from message mono.collab.v1.ShareConversationResponse
 */ export class ShareConversationResponse extends Message {
    static fromBinary(bytes, options) {
        return new ShareConversationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareConversationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareConversationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareConversationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.collab.v1.ShareSummary shares = 1;
   */ _define_property(this, "shares", []), /**
   * @generated from field: repeated mono.collab.v1.ShareError errors = 2;
   */ _define_property(this, "errors", []), /**
   * share_link is the full URL form (https://<host>/shared/<token>) for
   * the link share when create_link was true. Empty when no link share
   * was created. The frontend uses this directly without re-deriving
   * from link_token.
   *
   * @generated from field: string share_link = 3;
   */ _define_property(this, "shareLink", ""), /**
   * Counts of notifications attempted vs queued. Today these always
   * match (fire-and-forget) but the shape is preserved for a future
   * delivery confirmation path.
   *
   * @generated from field: int32 notifications_attempted = 4;
   */ _define_property(this, "notificationsAttempted", 0), /**
   * @generated from field: int32 notifications_queued = 5;
   */ _define_property(this, "notificationsQueued", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShareConversationResponse, "runtime", proto3);
_define_property(ShareConversationResponse, "typeName", "mono.collab.v1.ShareConversationResponse");
_define_property(ShareConversationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "shares",
            kind: "message",
            T: ShareSummary,
            repeated: true
        },
        {
            no: 2,
            name: "errors",
            kind: "message",
            T: ShareError,
            repeated: true
        },
        {
            no: 3,
            name: "share_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notifications_attempted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "notifications_queued",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * GetShareSettings returns the share state for a chat — direct
 * recipients and an optional link share — for the owner's settings UI.
 *
 * @generated from message mono.collab.v1.GetShareSettingsRequest
 */ export class GetShareSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetShareSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetShareSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetShareSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetShareSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetShareSettingsRequest, "runtime", proto3);
_define_property(GetShareSettingsRequest, "typeName", "mono.collab.v1.GetShareSettingsRequest");
_define_property(GetShareSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.DirectShareView
 */ export class DirectShareView extends Message {
    static fromBinary(bytes, options) {
        return new DirectShareView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DirectShareView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DirectShareView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DirectShareView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string share_id = 1;
   */ _define_property(this, "shareId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string email = 3;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DirectShareView, "runtime", proto3);
_define_property(DirectShareView, "typeName", "mono.collab.v1.DirectShareView");
_define_property(DirectShareView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "share_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.collab.v1.LinkShareView
 */ export class LinkShareView extends Message {
    static fromBinary(bytes, options) {
        return new LinkShareView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkShareView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkShareView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkShareView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string share_id = 1;
   */ _define_property(this, "shareId", ""), /**
   * @generated from field: bool enabled = 2;
   */ _define_property(this, "enabled", false), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */ _define_property(this, "expiresAt", void 0), /**
   * @generated from field: string url = 4;
   */ _define_property(this, "url", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkShareView, "runtime", proto3);
_define_property(LinkShareView, "typeName", "mono.collab.v1.LinkShareView");
_define_property(LinkShareView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "share_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.ShareLimits
 */ export class ShareLimits extends Message {
    static fromBinary(bytes, options) {
        return new ShareLimits().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareLimits().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareLimits().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareLimits, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 max_direct_shares = 1;
   */ _define_property(this, "maxDirectShares", 0), /**
   * @generated from field: int32 current_direct_shares = 2;
   */ _define_property(this, "currentDirectShares", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ShareLimits, "runtime", proto3);
_define_property(ShareLimits, "typeName", "mono.collab.v1.ShareLimits");
_define_property(ShareLimits, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "max_direct_shares",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "current_direct_shares",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.GetShareSettingsResponse
 */ export class GetShareSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetShareSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetShareSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetShareSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetShareSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool is_owner = 1;
   */ _define_property(this, "isOwner", false), /**
   * @generated from field: repeated mono.collab.v1.DirectShareView direct_shares = 2;
   */ _define_property(this, "directShares", []), /**
   * link_share is unset when the chat has no active link share. Optional
   * semantics rather than a sentinel empty struct so the JS shape
   * matches `linkShare?: LinkShareView`.
   *
   * @generated from field: mono.collab.v1.LinkShareView link_share = 3;
   */ _define_property(this, "linkShare", void 0), /**
   * @generated from field: mono.collab.v1.ShareLimits limits = 4;
   */ _define_property(this, "limits", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetShareSettingsResponse, "runtime", proto3);
_define_property(GetShareSettingsResponse, "typeName", "mono.collab.v1.GetShareSettingsResponse");
_define_property(GetShareSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "is_owner",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "direct_shares",
            kind: "message",
            T: DirectShareView,
            repeated: true
        },
        {
            no: 3,
            name: "link_share",
            kind: "message",
            T: LinkShareView
        },
        {
            no: 4,
            name: "limits",
            kind: "message",
            T: ShareLimits
        }
    ]));
/**
 * ToggleLinkShare flips the link share's enabled bit. The handler
 * re-reads + returns the updated state.
 *
 * @generated from message mono.collab.v1.ToggleLinkShareRequest
 */ export class ToggleLinkShareRequest extends Message {
    static fromBinary(bytes, options) {
        return new ToggleLinkShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ToggleLinkShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ToggleLinkShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ToggleLinkShareRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: bool enabled = 2;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ToggleLinkShareRequest, "runtime", proto3);
_define_property(ToggleLinkShareRequest, "typeName", "mono.collab.v1.ToggleLinkShareRequest");
_define_property(ToggleLinkShareRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.ToggleLinkShareResponse
 */ export class ToggleLinkShareResponse extends Message {
    static fromBinary(bytes, options) {
        return new ToggleLinkShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ToggleLinkShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ToggleLinkShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ToggleLinkShareResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string share_id = 1;
   */ _define_property(this, "shareId", ""), /**
   * @generated from field: bool enabled = 2;
   */ _define_property(this, "enabled", false), /**
   * @generated from field: string url = 3;
   */ _define_property(this, "url", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ToggleLinkShareResponse, "runtime", proto3);
_define_property(ToggleLinkShareResponse, "typeName", "mono.collab.v1.ToggleLinkShareResponse");
_define_property(ToggleLinkShareResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "share_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * RotateShareLink mints a new token for the chat's link share. The
 * old URL becomes dead immediately (matches pangaea's atomic
 * soft-delete-then-insert rotation contract).
 *
 * @generated from message mono.collab.v1.RotateShareLinkRequest
 */ export class RotateShareLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new RotateShareLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RotateShareLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RotateShareLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RotateShareLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RotateShareLinkRequest, "runtime", proto3);
_define_property(RotateShareLinkRequest, "typeName", "mono.collab.v1.RotateShareLinkRequest");
_define_property(RotateShareLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.RotateShareLinkResponse
 */ export class RotateShareLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new RotateShareLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RotateShareLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RotateShareLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RotateShareLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string share_id = 1;
   */ _define_property(this, "shareId", ""), /**
   * @generated from field: string url = 2;
   */ _define_property(this, "url", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RotateShareLinkResponse, "runtime", proto3);
_define_property(RotateShareLinkResponse, "typeName", "mono.collab.v1.RotateShareLinkResponse");
_define_property(RotateShareLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "share_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * RevokeShare removes a specific share by id. Direct shares: revokes
 * the recipient's access. Link share: revokes the link (token is freed
 * for reuse via the partial unique index).
 *
 * @generated from message mono.collab.v1.RevokeShareRequest
 */ export class RevokeShareRequest extends Message {
    static fromBinary(bytes, options) {
        return new RevokeShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeShareRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string share_id = 2;
   */ _define_property(this, "shareId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevokeShareRequest, "runtime", proto3);
_define_property(RevokeShareRequest, "typeName", "mono.collab.v1.RevokeShareRequest");
_define_property(RevokeShareRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "share_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.RevokeShareResponse
 */ export class RevokeShareResponse extends Message {
    static fromBinary(bytes, options) {
        return new RevokeShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeShareResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevokeShareResponse, "runtime", proto3);
_define_property(RevokeShareResponse, "typeName", "mono.collab.v1.RevokeShareResponse");
_define_property(RevokeShareResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.ListSharedWithMeRequest
 */ export class ListSharedWithMeRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSharedWithMeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSharedWithMeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSharedWithMeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSharedWithMeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Pagination is intentionally flat — the inbox is bounded and the
   * express handler today returns the full list. Adding cursor
   * pagination here would be a frontend-side change too; deferring.
   *
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: string search = 3;
   */ _define_property(this, "search", ""), /**
   * sort_by accepts 'createdAt' (default) or 'title'. Empty → createdAt.
   *
   * @generated from field: string sort_by = 4;
   */ _define_property(this, "sortBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSharedWithMeRequest, "runtime", proto3);
_define_property(ListSharedWithMeRequest, "typeName", "mono.collab.v1.ListSharedWithMeRequest");
_define_property(ListSharedWithMeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.SharedChatPreview
 */ export class SharedChatPreview extends Message {
    static fromBinary(bytes, options) {
        return new SharedChatPreview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SharedChatPreview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SharedChatPreview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SharedChatPreview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string shared_by_user_id = 3;
   */ _define_property(this, "sharedByUserId", ""), /**
   * @generated from field: string shared_by_name = 4;
   */ _define_property(this, "sharedByName", ""), /**
   * @generated from field: string shared_by_email = 5;
   */ _define_property(this, "sharedByEmail", ""), /**
   * @generated from field: google.protobuf.Timestamp shared_at = 6;
   */ _define_property(this, "sharedAt", void 0), /**
   * last_message_preview / last_message_role / last_message_created_at
   * are flat rather than a nested LastMessage to keep the JS shape one
   * hop deep (matches the express response). Empty values when the
   * chat has no messages.
   *
   * @generated from field: string last_message_role = 7;
   */ _define_property(this, "lastMessageRole", ""), /**
   * @generated from field: string last_message_preview = 8;
   */ _define_property(this, "lastMessagePreview", ""), /**
   * @generated from field: google.protobuf.Timestamp last_message_created_at = 9;
   */ _define_property(this, "lastMessageCreatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SharedChatPreview, "runtime", proto3);
_define_property(SharedChatPreview, "typeName", "mono.collab.v1.SharedChatPreview");
_define_property(SharedChatPreview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "shared_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "shared_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "shared_by_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "shared_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "last_message_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "last_message_preview",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "last_message_created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.collab.v1.Pagination
 */ export class Pagination extends Message {
    static fromBinary(bytes, options) {
        return new Pagination().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Pagination().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Pagination().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Pagination, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total = 1;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 page = 2;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 total_pages = 4;
   */ _define_property(this, "totalPages", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Pagination, "runtime", proto3);
_define_property(Pagination, "typeName", "mono.collab.v1.Pagination");
_define_property(Pagination, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "total_pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.ListSharedWithMeResponse
 */ export class ListSharedWithMeResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSharedWithMeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSharedWithMeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSharedWithMeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSharedWithMeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.collab.v1.SharedChatPreview chats = 1;
   */ _define_property(this, "chats", []), /**
   * @generated from field: mono.collab.v1.Pagination pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSharedWithMeResponse, "runtime", proto3);
_define_property(ListSharedWithMeResponse, "typeName", "mono.collab.v1.ListSharedWithMeResponse");
_define_property(ListSharedWithMeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chats",
            kind: "message",
            T: SharedChatPreview,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: Pagination
        }
    ]));
/**
 * @generated from message mono.collab.v1.ResolveShareTokenRequest
 */ export class ResolveShareTokenRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveShareTokenRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveShareTokenRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveShareTokenRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveShareTokenRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string token = 1;
   */ _define_property(this, "token", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveShareTokenRequest, "runtime", proto3);
_define_property(ResolveShareTokenRequest, "typeName", "mono.collab.v1.ResolveShareTokenRequest");
_define_property(ResolveShareTokenRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.ResolveShareTokenResponse
 */ export class ResolveShareTokenResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveShareTokenResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveShareTokenResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveShareTokenResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveShareTokenResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string shared_by_name = 3;
   */ _define_property(this, "sharedByName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveShareTokenResponse, "runtime", proto3);
_define_property(ResolveShareTokenResponse, "typeName", "mono.collab.v1.ResolveShareTokenResponse");
_define_property(ResolveShareTokenResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "shared_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LogArtifactToChat appends a single assistant message to a conversation
 * recording that an artifact (sheet/text/code/image) was saved. The
 * payload mirrors express's POST /api/chat/log-save body.
 *
 * @generated from message mono.collab.v1.LogArtifactToChatRequest
 */ export class LogArtifactToChatRequest extends Message {
    static fromBinary(bytes, options) {
        return new LogArtifactToChatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogArtifactToChatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogArtifactToChatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogArtifactToChatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string chat_id = 1;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * kind matches the existing allowed set: sheet / text / code / image.
   * Other values are accepted (logged at server) — UI evolves faster
   * than the proto, and enforcing a closed set here would break
   * adventurous frontend kinds.
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * content is the textual representation of the saved artifact;
   * empty when the kind has no inline content (e.g. images by URL).
   *
   * @generated from field: string content = 5;
   */ _define_property(this, "content", ""), /**
   * version_created_at is the ISO timestamp the frontend computed at
   * save time. Empty → server uses now.
   *
   * @generated from field: string version_created_at = 6;
   */ _define_property(this, "versionCreatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogArtifactToChatRequest, "runtime", proto3);
_define_property(LogArtifactToChatRequest, "typeName", "mono.collab.v1.LogArtifactToChatRequest");
_define_property(LogArtifactToChatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version_created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.collab.v1.LogArtifactToChatResponse
 */ export class LogArtifactToChatResponse extends Message {
    static fromBinary(bytes, options) {
        return new LogArtifactToChatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogArtifactToChatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogArtifactToChatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogArtifactToChatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message_id = 1;
   */ _define_property(this, "messageId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogArtifactToChatResponse, "runtime", proto3);
_define_property(LogArtifactToChatResponse, "typeName", "mono.collab.v1.LogArtifactToChatResponse");
_define_property(LogArtifactToChatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
